import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Home from './pages/Home/Home';
import './App.css'; // Global or app-wide styles

// Import other individual components for routing if needed
import About from './components/About/About';
import Portfolio from './components/Portfolio/Portfolio';
import Projects from './components/Projects/Projects';
import Contact from './components/Contact/Contact';

// Legal pages
import LiftLogLanding from './pages/LifeLog/LiftLog';
import LiftLogSupport from './pages/LifeLog/Support';
import LiftLogTerms from './pages/LifeLog/Terms';
import LiftLogPrivacy from './pages/LifeLog/Privacy';
import CVProTerms from './pages/CVPro/Terms';
import CVProPrivacy from './pages/CVPro/Privacy';
import InvoSyncTerms from './pages/InvoSync/Terms';
import InvoSyncPrivacy from './pages/InvoSync/Privacy';

const theme = createTheme({
    palette: {
        mode: 'dark',
        primary: {
            main: '#FFFFFF',
        },
        background: {
            default: '#191B1D',
            paper: '#1A1B1D',
        },
    },
    typography: {
        fontFamily: "'Inter', 'Helvetica Neue', Arial, sans-serif",
        h4: { fontWeight: 700 },
        h5: { fontWeight: 600, letterSpacing: '-0.01em' },
        h6: { fontWeight: 600 },
        body2: { color: '#999' },
    },
    shape: {
        borderRadius: 12,
    },
    components: {
        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundColor: '#121212',
                    boxShadow: 'none',
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    backgroundImage: 'none',
                    borderRadius: 12,
                    border: '1px solid rgba(255,255,255,0.06)',
                    transition: 'border-color 180ms ease, transform 180ms ease',
                    '&:hover': {
                        borderColor: 'rgba(255,255,255,0.14)',
                    },
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    fontWeight: 500,
                    borderRadius: 8,
                },
            },
        },
        MuiModal: {
            styleOverrides: {
                root: {
                    backdropFilter: 'blur(4px)',
                },
            },
        },
    },
});

const App = () => {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Router>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/portfolio" element={<Portfolio />} />
                    <Route path="/projects" element={<Projects />} />
                    <Route path="/contact" element={<Contact />} />

                    {/* LiftLog */}
                    <Route path="/liftlog" element={<LiftLogLanding />} />
                    <Route path="/liftlog/support" element={<LiftLogSupport />} />
                    <Route path="/liftlog/terms" element={<LiftLogTerms />} />
                    <Route path="/liftlog/privacy" element={<LiftLogPrivacy />} />

                    {/* CVPro */}
                    <Route path="/cvpro/terms" element={<CVProTerms />} />
                    <Route path="/cvpro/privacy" element={<CVProPrivacy />} />

                    {/* InvoSync */}
                    <Route path="/invosync/terms" element={<InvoSyncTerms />} />
                    <Route path="/invosync/privacy" element={<InvoSyncPrivacy />} />
                </Routes>
            </Router>
        </ThemeProvider>
    );
};

export default App;
